
export const API_URL = "https://catalogo-tucompra.onrender.com";
//export const API_URL = "http://localhost:4000";
